import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import request from '@vaersaagod/tools/request';
import * as Events from '../lib/events';

export default (el, props) => {
    const dom = $(el);

    let currentBreakpoint = null;

    const onBreakpoint = data => {
        currentBreakpoint = Viewport.breakpoint.size;

        if (currentBreakpoint >= 1200 && data.detail.old.size < 1200) {

        } else if (currentBreakpoint < 1200 && data.detail.old.size >= 1200) {

        }
    };

    const init = () => {
        currentBreakpoint = Viewport.breakpoint.size;
        Viewport.on('breakpoint', onBreakpoint);
        
    };

    const destroy = () => {
        Viewport.off('breakpoint', onBreakpoint);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Menu.js